module.exports = require('./helpers/bundle-url').getBundleURL('pXguj') + "logo-dark.a922e36b.svg";